import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon({ color = 'currentColor' }) {
  return (
    <svg
      t="1641362463536"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1212"
      width="16"
      height="16"
    >
      <path
        d="M3.68941231,7.27030128 L8.14903202,2.8107068 L12.6086513,7.27030167 L11.6894123,8.18956505 L8.14903194,4.64915986 L4.60865135,8.18956505 L3.68941231,7.27030128 Z M3.68941231,12.270225 L8.14903202,7.81063051 L12.6086513,12.2702254 L11.6894123,13.1894888 L8.14903194,9.64908356 L4.60865135,13.1894888 L3.68941231,12.270225 Z"
        fill={color}
        fill-rule="evenodd"
      />
    </svg>
  )
}

const FoldUpIcon = (props) => {
  const { fill = 'black', width = 20, height = 20 } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon width={width} height={height} />
    </MorphReplace>
  )
}

// 默认参数
FoldUpIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'black',
}
// 参数类型
FoldUpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default FoldUpIcon
